<template>
  <v-card class="rounded-lg pa-2 white pb-8" flat>
    <v-card-title class="secondary--text">
      <v-spacer></v-spacer>
      {{ title }}
      <v-spacer></v-spacer>
      <chart-export-btn :page-chart-id="chartId"></chart-export-btn>
    </v-card-title>

    <v-card-subtitle class="text-center grey--text">{{ subtitle }}</v-card-subtitle>

    <div v-if="loading" class="text-center pa-8">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <canvas v-show="!loading" :id="chartId"></canvas>
  </v-card>
</template>

<script>
import Chart from "chart.js";
// import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: "GroupedBarChart",
//   components: { ChartExportBtn },

  props: {
    /**
     * عنوان نمودار
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * زیرعنوان نمودار
     */
    subtitle: {
      type: String,
      default: "",
    },
    /**
     * آدرس API — باید آرایه‌ای از آبجکت برگردونه.
     * هر آبجکت باید فیلد dateKey رو داشته باشه + فیلدهایی که در datasets تعریف شده.
     * مثال: [{ date: "1404/02/21", morning: 10, evening: 20, night: 5 }, ...]
     */
    url: {
      type: String,
      required: true,
    },
    /**
     * تعریف ستون‌های نمودار
     * هر آیتم: { key: string, label: string, color: string }
     * مثال:
     * [
     *   { key: "morning", label: "صبح (۹-۱۷)", color: "#FFC700" },
     *   { key: "evening", label: "عصر (۱۷-۱)", color: "#50CC89" },
     *   { key: "night",   label: "شب (۱-۹)",   color: "#43CED7" },
     * ]
     */
    datasets: {
      type: Array,
      required: true,
    },
    /**
     * کلید فیلد تاریخ در هر آبجکت داده
     */
    dateKey: {
      type: String,
      default: "date",
    },
    /**
     * شناسه یکتا برای canvas — اگه چند بار استفاده میکنی حتماً متفاوت بذار
     */
    chartId: {
      type: String,
      default: "grouped-bar-chart",
    },
  },

  data() {
    return {
      loading: false,
      chartInstance: null,
    };
  },

  mounted() {
    this.fetchAndRender();
  },

  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },

  methods: {
    fetchAndRender() {
      this.loading = true;
      this.request({
        url: this.endpoint(this.url),
        method: "get",
        success: (data) => {
          this.loading = false;
          this.$nextTick(() => this.renderChart(data));
        },
        error: () => {
          this.loading = false;
        },
      });
    },

    renderChart(data) {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const labels = data.map((item) => item[this.dateKey]);

      const chartDatasets = this.datasets.map((ds) => ({
        label: ds.label,
        data: data.map((item) => item[ds.key] ?? 0),
        backgroundColor: ds.color,
        borderColor: ds.color,
        borderWidth: 1,
        borderRadius: 4,
      }));

      const ctx = document.getElementById(this.chartId);
      if (!ctx) return;

      this.chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels,
          datasets: chartDatasets,
        },
        options: {
          responsive: true,
          legend: {
            position: "bottom",
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontFamily: "IRANSans, sans-serif",
                  fontSize: 11,
                },
                gridLines: { display: false },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  fontFamily: "IRANSans, sans-serif",
                },
                gridLines: { color: "#f0f0f0" },
              },
            ],
          },
          tooltips: {
            mode: "index",
            intersect: false,
          },
        },
      });
    },
  },
};
</script>